"use strict";
var ArrayBufferViewCore = require("../internals/array-buffer-view-core");
var uncurryThis = require("../internals/function-uncurry-this");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $join = uncurryThis([].join);
exportTypedArrayMethod("join", function join(separator) {
  return $join(aTypedArray(this), separator);
});
